import { type CartIntermediateEntryObject } from './CartIntermediateContextValue'

/* This function extracts the product ID from a cart entry object.
 * product is a union type that can be either a CrossSellProduct, PimProductWithVariantsV1, PimProductV12, PimProductV13 .
 * If the product has a 'upid' property, it returns that; otherwise, it returns the 'id' property.
 * If the product is undefined, it returns undefined.
 */
export const cartIntermediateAccessorGetProductIdFromCartEntry = ({
  cartIntermediateEntryObject,
}: {
  cartIntermediateEntryObject: CartIntermediateEntryObject | undefined
}): string | undefined => {
  if (
    cartIntermediateEntryObject &&
    'product' in cartIntermediateEntryObject &&
    cartIntermediateEntryObject.product
  ) {
    const { product } = cartIntermediateEntryObject

    if ('upid' in product && typeof product.upid === 'string') {
      return product.upid
    }
    if ('id' in product && typeof product.id === 'string') {
      return product.id
    }

    return undefined
  }

  return undefined
}
